import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../Modal';
import useForm from '../../hooks/useForm';
import Form from '../Form';
import { remove } from 'lodash';
import { sendNewsLetter } from '../../apis/admin/newsletter';
import { toast } from '../../utils/toast';
import { isEmpty } from '../../utils/lodashExtend';
import systemAlert from '../../utils/systemAlert';
import { cleanObj } from '../../utils/cleanObj';
import { viewLoading } from '../../utils/loading';

const defaultForm = { isSubscriber: "false", footerType: "logo" };

const ydsTargetList = [
  { label: "구독자", value: "subscribe" },
  { label: "컨설팅(상담신청)", value: "consultings" },
  { label: "무료버전사용자", value: "freeUser" },
  { label: "파트너세무사", value: "partner" },
];

const partnerTargetList = [
  { label: "구독자", value: "subscribe" },
];

const MailSendModal = (props) => {
  const { open, setOpen, selectedItem, setSelectedItem, type = "YDS" } = props;
  const [checkedList, setCheckedList] = useState(["subscribe"]);
  const [fields, setFields] = useState([]);
  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    setForm({
      ...defaultForm,
      ...(type === "PARTNER" ? { isSubscriber: "false" } : {})
    });
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  const _submit = () => {
    viewLoading('메일 전송 요청중입니다.');
    const params = {
      idx: selectedItem.idx,
      target: checkedList,
      type,
      ...(type === "PARTNER" ? { isSubscriber: form.isSubscriber || false, footerType: form.footerType } : {})
    };

    if (type === "YDS" && isEmpty(checkedList)) {
      systemAlert("메일 대상을 하나이상 선택해야 합니다.");
    } else {
      cleanObj(params);
      sendNewsLetter(params).then(res => {
        toast.success("메일 전송요청이 완료되었습니다.");
        cancel();
      }).catch((err) => {
        console.error(err);
      }).finally(() => viewLoading(false));
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setFields([[
      {
        title: "메일 대상 선택",
        key: "categories",
        type: "checkboxes",
        required: true,
        className: "margin-right-16",
        checkedList,
        options: {
          list: (type === "PARTNER" ? partnerTargetList : ydsTargetList) || [],
        },
        isHide: type === "PARTNER",
        onChange: (checked, value) => {
          let _selectedCheckboxes = [];
          if (checked) {
            _selectedCheckboxes = [...checkedList, value];
          } else {
            _selectedCheckboxes = remove(checkedList, (v) => v !== value);
          }
          setCheckedList(_selectedCheckboxes);
        }
      },
    ],
    ...(type === "PARTNER" ? [
      {
        title: "구독자 포함 발송",
        key: "isSubscriber",
        type: "radio",
        options: {
          list: [{ label: '포함', value: "true" }, { label: '미포함', value: "false" }]
        },
      }] : []),
    ]);

  }, [checkedList, type]);


  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {`뉴스레터 [${selectedItem?.title}] 메일 발송하기`}
        </ModalHeader>
        <Form
          fields={fields}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          onChange={handleOnChange}
          submitText={"메일 발송"}
          submit={handleSubmit}
        />
      </Modal>
    </>
  );
};

export default MailSendModal;